module.exports = __webpack_public_path__ + "static/media/iconDownload2.9ef44987.svg";